import api from "../../config/client.axios.api";

export const getInfoApiRequest = async (clearToken?: () => void) => {
  try {
    const response = await api.get(`/account/detail`);
    return response.data;
  } catch (error) {
    clearToken!();
  }
};
